<template>
    <div class="Landing-page">
        <!-- <img :src="isDesktop ? bannerImg:bannerMobImg" v-show="loader" alt=""> -->
        <div class="headtop prelative" v-show="isComboActive && homeLandingBanners && homeLandingBanners.length">
        <div v-for="(bimg, index) in homeLandingBanners" :key="index">
        <div  class='prelative'  v-if="bimg.image ">
          <router-link :to="bimg.url ? bimg.url : '/men'" :aria-label="bimg.promotion_name || 'Home Banner'">
            <img  class="fullWidth" :src="isDesktop ? bimg.image : bimg.mobile_image" :alt="bimg.name || 'TSS Banner'" >
            <div class="show-more-btn" v-if="bimg.is_viewmore_button_visible">
              <span class='show-more-btn-txt'>{{bimg.name}}</span>
            </div>
          </router-link>
          <div v-if="bimg.is_split_banner" class='row splitted-navigation-container col-12'>
            <router-link :to="bimg.url ? bimg.url : '/men'" aria-label="left url" class="col-6 h-100"></router-link>
            <router-link :to="bimg.right_url ? bimg.right_url : '/men'" aria-label="right url" class='col-6 h-100'></router-link>
          </div>
        </div>
      </div>
    </div>
    </div>

</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import {appMixins} from '../assets/js/appMixins'
import {metaElements} from '../assets/js/metaElements'
// import debounce from 'lodash/debounce'

export default {
  name: 'LandingPage',
  mixins: [metaElements, appMixins],
  data () {
    return {
      loader: false,
      isDesktop: this.$parent.isDesktop,
      // bannerImg: this.isSelectedCountryIndia ? process.env.IMG_BASE_URL + 'public/theSoul/storage/mobile-cms-media-prod/home-landing-web/Homepage_Banners_1920x655_38aEuqC.jpg?format=webp&w=1500&dpr=1.0' : process.env.IMG_BASE_URL + 'public/theSoul/storage/mobile-cms-media-prod/home-landing-web/Splash_Banner_web_final_zemNCHc.jpg?format=webp&w=1280&dpr=0.9',
      // bannerMobImg: this.isSelectedCountryIndia ? process.env.IMG_BASE_URL + 'public/theSoul/storage/mobile-cms-media-prod/home-landing-web/Banners-700x900.jpg?format=webp&w=700&dpr=1.0x' : process.env.IMG_BASE_URL + 'public/theSoul/storage/mobile-cms-media-prod/home-landing-web/splash_banner_app_copy_new_dba5mOo.jpg?format=webp&w=376&dpr=2.0',
      googleAdwordsId: process.env.GOOGLE_ADWORDS_ID

    }
  },
  methods: {
    getHomeScreenData: function () {
      this.$store.dispatch('GET_HOME_SCREEN_DATA', {isComboActive: this.isComboActive})
    }
    // loadData: debounce(function () {
    //   this.loader = false
    // }, 3600)
  },
  computed: {
    ...mapGetters(
      [
        'homeScreenData',
        'isComboActive',
        'isSelectedCountryIndia'
      ]
    ),
    bannerImg () {
      return this.isSelectedCountryIndia
        ? process.env.IMG_BASE_URL + 'public/theSoul/storage/mobile-cms-media-prod/home-landing-web/webpage__copy.jpg?format=webp&w=1536&dpr=1.3'
        : process.env.IMG_BASE_URL + 'public/theSoul/storage/mobile-cms-media-prod/home-landing-web/Splash_Banner_web_final_zemNCHc.jpg?format=webp&w=1500&dpr=0.9'
    },
    bannerMobImg () {
      return this.isSelectedCountryIndia
        ? process.env.IMG_BASE_URL + 'public/theSoul/storage/mobile-cms-media-prod/home-landing-web/Banners-700x900.jpg?format=webp&w=700&dpr=1.0x'
        : process.env.IMG_BASE_URL + 'public/theSoul/storage/mobile-cms-media-prod/home-landing-web/splash_banner_app_copy_new_dba5mOo.jpg?format=webp&w=700&dpr=2.0'
    },
    homeLandingBanners: function () {
      const data = this.isComboActive ? this.homeScreenData && Object.keys(this.homeScreenData).length && this.homeScreenData['Home Landing Web'] : this.homeData && this.homeData.gallery
      return data
    }
  },
  mounted () {
    // this.loadData()
    const gender = Vue.ls.get('tss_landingCategory')
    this.$store.commit('GTAG_EVENT', {eventName: 'page_view',
      payload: {
        sendTo: this.googleAdwordsId,
        ecomm_pagetype: 'home',
        gender: gender,
        page_title: 'home_page'
      }}
    )
    this.$store.commit('GTAG_EVENT', {eventName: 'ct_page_viewed_custom', payload: {pdp_response: (Vue.ls.get('routeObj')).current}})
    this.$store.commit('GTAG_EVENT', {eventName: 'Page_Viewed', payload: {pdp_response: (Vue.ls.get('routeObj')).current}})
  },
  watch: {
    isComboActive: function () {
      this.getHomeScreenData()
    },
    homeScreenData () {
      const banners = this.homeLandingBanners
      if (banners && banners.length > 0) {
        const allImagesInvalid = banners.every(element => !this.isValidImageUrlWithFormatCheck(element.image))
        if (allImagesInvalid) {
          this.$router.push('/men')
        }
      }
    }
  }
}
</script>

<style lang="css" scoped>
  [v-cloak] {
    background: #ed2d2f;
  }
  .show-more-btn{
    position: absolute;
    width: 100%;
    bottom: 16%;
    text-align: center;
  }
  .show-more-btn-txt {
    display: inline;
    color: rgb(0, 0, 0);
    border-color: rgb(4, 251, 251);
    border-style: solid;
    border-width: 2px;
    background: rgb(4, 251, 251) none repeat scroll 0% 0%;
  }
  .fullWidth {
    width:100%;
  }
  .splitted-navigation-container {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .headtop {
    background-color: #ffffff;
  }
  @media screen and (max-width: 768px) {
    .headtop {
      /* padding-bottom: 0.3rem; */
    }
  }
  @media screen and (max-width: 991px) {
    .container {
      padding-right: 7px;
      padding-left: 7px;
    }
  }
  @media screen and (min-width: 992px) {
    .exclusive-tile {
      margin-bottom: 14px;
    }
  }

  @media (min-width: 1200px) {
    .tilethumb {
      margin-bottom: 19px;
    }
  }
</style>



// WEBPACK FOOTER //
// LandingPage.vue?0b948c54